import '.a{display:grid;}.ssr-plugin'
import '.k{gap:2rem;}.ssr-plugin'
import { styled } from 'inlines'
import { ServiceProviderCard } from '@app/components/blocks/card/ServiceProviderCard'
import { ViewHousingFormModel } from 'functions/app/housing-form/view'
import useMediaQuery from '@app/util/useMediaQuery'

export const HousingFormPageExperts = ({
  housingForm,
}: {
  housingForm: ViewHousingFormModel
}) => {
  const isMobile = useMediaQuery()

  return (
    <div className="a k"
      style={{
        gridTemplateColumns: isMobile
          ? 'repeat(1, minmax(250px, 1fr))'
          : 'repeat(2, minmax(250px, 1fr))',}}
    >
      {(housingForm.serviceProviders ?? []).map((expert) => (
        <ServiceProviderCard
          key={expert.id}
          slug={expert.slug}
          name={expert.name}
          description={expert.description}
          bannerSrc={expert.banner?.src}
          avatarSrc={expert.avatar?.src}
          types={expert.type}
        />
      ))}
    </div>
  )
}
